import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  style: string;
  label: string;
  icon?: ReactNode;
  lowercase?: boolean;
  extraClasses?: string;
};

const TicketTag: FC<Props> = ({
  style,
  label,
  icon,
  lowercase,
  extraClasses,
}) => {
  const { t } = useTranslation();
  const styleModified: string = style?.toLocaleLowerCase();
  const defStyle = ``;

  const styles = {
    gesloten: 'bg-red-100 text-red-700 px-2 text-[11px]',
    prior: 'bg-red-50 text-red-600 px-2 border border-red-200 text-[10px]',
    toegewezen: 'bg-blue-50 text-blue-600 px-2 text-[11px]',
    open: 'bg-green-50 text-green-700 px-2 border border-green-700 text-[11px]',
  };

  return (
    <span
      className={`inline-flex items-center gap-1 flex-row rounded-md font-bold ${
        lowercase ? '' : 'uppercase'
      } ${styles[styleModified]} ${extraClasses}`}
    >
      {icon} {t(label)}
    </span>
  );
};

export default TicketTag;
